<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="search">
                <form action="search-results.html" method="get">
                    <input id="search" name="search" type="text" [(ngModel)]="revcode"
                     (change)="retriveRvenueLookup()" placeholder="Code" >
                    <label>                      </label>
                    <input id="search" name="search" type="text" [(ngModel)]="revname"
                    (change)="retriveRvenueLookup()"placeholder="Name"  >

                </form>
            </div>
        </div>
    </div>
  </section>

  <table>
    <thead>
        <tr >
            <th style="width: 30%;">Code</th>
            <th style="width: 100%;">Name</th>
            <th style="width: 20%;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Rom of revenueList; let i = index">
            <td data-column="Room Code">{{Rom.revcode}}</td>
            <td data-column="Room Name">{{Rom.revname}}</td>
            <td data-column="Choose"><button type="button" class="theme-button btn" name="select" id="select" (click)="SelectRevenue(Rom)">Select</button>
            </td>
        </tr>

    </tbody>
  </table>
  </mat-dialog-content>

